export const WEBSITE_URL =
  import.meta.env.VITE_WEBSITE_URL ?? 'https://play.dev.mydra.io'
export const MYDRA_WORKSPACE_ID_COOKIE_NAME =
  import.meta.env.VITE_MYDRA_WORKSPACE_ID_COOKIE_NAME ?? 'mydraworkspaceidloc'
export const MYDRA_WORKSPACE_ID_HEADER_NAME =
  import.meta.env.VITE_MYDRA_WORKSPACE_ID_HEADER_NAME ?? 'active-workspace-id'
export const GTM_CONTAINER_ID =
  import.meta.env.VITE_GTM_CONTAINER_ID ?? 'GTM-5BSWFNTW'
export const GA_MEASUREMENT_ID =
  import.meta.env.VITE_GA_MEASUREMENT_ID ?? 'G-8Y0DV2WTBL'
export const HELP_SCOUT_BEACON_ID =
  import.meta.env.VITE_HELP_SCOUT_BEACON_ID ??
  'b0e8609e-0238-479b-99a1-1bcaceb5d598'
